import { motion } from "framer-motion";
import { Heart, MessageCircle } from "lucide-react";
import { photoLove } from "@/components/LoveSwipe";

/** Célébration plein écran lorsqu'un match se produit. */
export const LoveMatchAnimation = ({ moi, profil, onDiscuter, onContinuer }) => (
  <motion.div
    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
    data-testid="love-match-animation"
    className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-[#2F363F]/95 px-6 backdrop-blur-sm"
  >
    <motion.p
      initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 220, damping: 14 }}
      className="font-heading text-5xl font-extrabold text-[#FF4757] sm:text-6xl"
    >
      C'est un match !
    </motion.p>
    <p className="mt-3 text-center text-sm text-white/70">
      {profil.firstname} vous a aimé aussi. Le tchat sécurisé est ouvert.
    </p>

    <div className="mt-10 flex items-center">
      {[moi, profil].map((p, i) => (
        <motion.div key={p?.id || i}
          initial={{ x: i === 0 ? -80 : 80, opacity: 0, rotate: i === 0 ? -8 : 8 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 160, damping: 16 }}
          className={`h-32 w-32 overflow-hidden rounded-full border-4 border-white bg-stone-700 shadow-2xl sm:h-40 sm:w-40 ${
            i === 0 ? "mr-[-18px]" : "ml-[-18px]"
          }`}>
          <img src={photoLove({ photo: `/api/profiles/${p?.id}/photo` }, moi?.id)}
            alt={p?.firstname || ""} className="h-full w-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }} />
        </motion.div>
      ))}
      <motion.span
        initial={{ scale: 0 }} animate={{ scale: [0, 1.35, 1] }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="absolute flex h-14 w-14 items-center justify-center rounded-full bg-[#FF4757] text-white shadow-xl">
        <Heart size={26} fill="currentColor" />
      </motion.span>
    </div>

    <div className="mt-12 flex w-full max-w-sm flex-col gap-3">
      <button onClick={onDiscuter} data-testid="love-match-discuter"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#FF4757] px-6 py-4 text-sm font-bold text-white transition-transform hover:scale-[1.03]">
        <MessageCircle size={16} /> Discuter maintenant
      </button>
      <button onClick={onContinuer} data-testid="love-match-continuer"
        className="rounded-full border border-white/25 px-6 py-3.5 text-sm font-bold text-white/80 transition-colors hover:bg-white/10">
        Continuer à découvrir
      </button>
    </div>
  </motion.div>
);
